import type { Post_TPostId } from '../Post/Post.TPost'
import { Rout_create } from './Rout.create'
import { Rout_replace, Rout_to } from './Rout'
import { Rout_setBack } from './Rout.back'

type TTarget = { location?: number; workflow?: number; procedure?: number; postId?: Post_TPostId }

export const Rout_unitContentPageRoutePattern = '/unit/content/:unitId'

export interface Rout_UnitRoutesArgs {
    Unit_ContentPage: React.FunctionComponent<unknown>
}

export const Rout_UnitRoutes = (args: Rout_UnitRoutesArgs) => [
    Rout_create(Rout_unitContentPageRoutePattern, args.Unit_ContentPage),
]

/**
 * @param target Can provide extra contextual ids just to improve post ordering. Can pass `{}`.
 */
export function Rout_toUnitContentPage(unitId: number, target?: TTarget, back?: () => void) {
    Rout_setBack(back)
    Rout_to(`/unit/content/${unitId}`, target)
}

export function Rout_replaceUnitContentPage(unitId: number, target: TTarget) {
    Rout_replace(`/unit/content/${unitId}`, target)
}
